export default __webpack_public_path__ + "static/media/loader.96ef1e29.svg";